export default "__VITE_ASSET__CfQ5ZI2$__"